import React from 'react';
import Loader from 'react-loader-spinner';

const TableLoader = () => {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        marginTop: 40,
      }}
    >
      <Loader type="Oval" color="#00BFFF" height={40} width={40} />
    </div>
  );
};

export default TableLoader;
